/* eslint-disable react/no-unescaped-entities */
/* eslint-disable i18next/no-literal-string */
export const TermsAndConditionsFr = () => (
  <>
    <div>
      <h1>
        <span>
          <span lang="FR-CA">Conditions de service de Carson</span>
        </span>
      </h1>

      <p>
        <span>
          <span lang="FR-CA">
            Les conditions générales suivantes (les &quot;conditions de
            service&quot; ou le &quot;contrat&quot;) régissent l'accès d'un
            utilisateur (&quot;Utilisateur&quot;, &quot;vous&quot; ou
            &quot;votre&quot;) à ce portail des résidents (le
            &quot;service&quot;), un produit proposé par Carson Living, Inc.
            (&quot;fournisseur&quot;, &quot;nous&quot; ou &quot;notre&quot;).
            Nous notons que vous pouvez être, et les présentes conditions de
            service s'appliquent également à vous, que vous soyez, un édifice,
            une société de gestion d'un édifice ou un résident d'un édifice.
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            En vous inscrivant et en utilisant le service, vous reconnaissez
            avoir lu, compris et accepté d'être lié par les présentes conditions
            de service. Examinez attentivement les dispositions du présent
            Accord, car elles constituent des obligations légales contraignantes
            entre vous et le fournisseur. Nous pouvons réviser et mettre à jour
            les présentes conditions de service de temps à autre, à notre seule
            discrétion. Toutes les modifications entrent en vigueur dès leur
            publication et s'appliquent à tous les accès et utilisations du
            Service, du site Web ou de toute interface utilisateur. Votre
            utilisation continue du Service, du site Web ou de toute interface
            utilisateur après la publication des Conditions de service révisées
            constitue votre acceptation et votre accord pour être lié par les
            modifications. Si vous ne souhaitez pas être lié par le présent
            accord, ne vous inscrivez pas et n'utilisez pas le service.
          </span>
        </span>
      </p>

      <p style={{ fontWeight: 'bold' }}>
        <span lang="EN-US">
          1.
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">DESCRIPTION DU SERVICE</span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Le Service fournit une application Web et mobile permettant aux
            résidents et au personnel de l'édifice de communiquer et de gérer
            divers équipements et services de la communauté d'appartements. Le
            Service fonctionne comme un préposé à distance pour vos locaux en
            répondant au système d'interphone vidéo et audio pour permettre
            l'accès autorisé aux locaux et accepter les livraisons autorisées.
            Bien que le Service puisse contribuer à rendre vos locaux plus
            sécuritaire, il ne s'agit pas d'un service de gardiennage et il
            n'est pas fourni ou conçu pour remplacer ou fonctionner comme un
            service de sécurité ou de protection. En conséquence, vous acceptez
            et reconnaissez que le fournisseur n'est pas responsable de la
            sécurité ou de la sûreté de vos locaux, de vos invités et de votre
            personne et qu'il ne peut être tenu responsable envers vous ou tout
            autre tiers en cas d'incidents, de blessures ou de dommages
            survenant dans vos locaux ou à l'intérieur de ceux-ci.
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Vous reconnaissez et acceptez que les signaux transmis par des
            lignes téléphoniques, des fils, des connexions Internet, des ondes
            aériennes ou d'autres modes de communication passent par des réseaux
            de communication qui échappent totalement au contrôle du fournisseur
            et, par conséquent, le fournisseur ne sera pas responsable de toute
            défaillance qui empêche ou corrompt la transmission des
            communications associées au Service, y compris, sans s'y limiter,
            les alertes par SMS.
          </span>
        </span>
      </p>

      <p style={{ fontWeight: 'bold' }}>
        <span>
          <span lang="EN-US">
            2.
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            ENREGISTREMENT DU SERVICE ET SÉCURITÉ DU COMPTE
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Le Service vous est fourni par le Fournisseur conformément à
            l'accord de service que vous avez conclu avec le fournisseur, aux
            conditions générales des présentes conditions de service et à la
            condition expresse que vous restiez à jour dans tous vos paiements
            et obligations envers le fournisseur, dans la mesure où ils
            s'appliquent à vous.
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Pour vous inscrire et accéder au Service, il peut vous être demandé
            de fournir certains détails d'inscription ou d'autres informations.
            Il est une condition de votre utilisation du Service que toutes les
            informations que vous fournissez sur le site Web d’inscription et
            l’interface utilisateur sont correctes, à jour et complètes. En cas
            de modification des informations que vous nous fournissez, vous vous
            engagez à les mettre à jour immédiatement. Nous ne serons pas
            responsables des dommages que vous ou d'autres personnes pourraient
            subir du fait que vous ne nous avez pas fourni des informations
            complètes, exactes et à jour. Si l'une des informations qui nous
            sont fournies est inexacte, incomplète ou périmée, vous acceptez que
            nous puissions, à notre seule discrétion, bloquer votre utilisation
            ou votre accès au Service jusqu'à ce que l'information soit
            corrigée, complétée ou mise à jour.
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Vous acceptez que toutes les informations que vous fournissez pour
            vous inscrire à ce Service soient régies par notre politique de
            confidentialité et vous consentez à toutes les mesures que nous
            prenons à l'égard de vos informations conformément à notre politique
            de confidentialité.
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Si vous choisissez ou recevez un nom d'utilisateur, un mot de passe
            ou tout autre élément d'information dans le cadre de nos procédures
            de sécurité, vous devez traiter ces informations de manière
            confidentielle et ne pas les divulguer à d'autres personnes ou
            entités. Vous reconnaissez également que votre compte vous est
            personnel et acceptez de ne pas permettre à une autre personne
            d'accéder à ce Service ou à des parties de celui-ci en utilisant
            votre nom d'utilisateur, votre mot de passe ou d'autres informations
            de sécurité. Vous acceptez de nous informer immédiatement de tout
            accès non autorisé ou de toute utilisation de votre nom
            d'utilisateur ou de votre mot de passe, ou de toute autre violation
            de la sécurité. Vous acceptez également de vous assurer que vous
            quittez votre compte à la fin de chaque session. Vous devez être
            particulièrement prudent lorsque vous accédez à votre compte à
            partir d'un ordinateur public ou partagé afin que d'autres personnes
            ne puissent pas voir ou enregistrer votre mot de passe ou d'autres
            informations personnelles. Nous nous réservons le droit de
            désactiver tout nom d'utilisateur, mot de passe ou autre
            identifiant, qu'il ait été choisi par vous ou fourni par nous, à
            tout moment et à notre seule discrétion, pour quelque raison que ce
            soit ou sans raison, y compris si, à notre avis, vous avez violé
            l'une des dispositions des présentes conditions de service.
          </span>
        </span>
      </p>

      <p style={{ fontWeight: 'bold' }}>
        <span>
          <span lang="EN-US">
            3.
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;
            </span>
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            UTILISATION GÉNÉRALE DU SERVICE - AUTORISATIONS ET RESTRICTIONS
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Le fournisseur vous accorde une autorisation limitée, conditionnelle
            et révocable d'accéder au service et de l'utiliser, à condition que
            vous n'utilisiez le service qu'à des fins légales et conformément
            aux présentes conditions de service. Vous acceptez de ne pas
            utiliser le service :
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            D'une manière qui enfreint toute loi ou réglementation fédérale,
            nationale, locale ou internationale applicable (y compris, mais sans
            s'y limiter, toute loi concernant l'exportation de données ou de
            logiciels vers et depuis les États-Unis ou d'autres pays).
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Dans le but d'exploiter, de nuire ou de tenter d'exploiter ou de
            nuire à des mineurs de quelque manière que ce soit en les exposant à
            un contenu inapproprié, en leur demandant des informations
            personnellement identifiables ou de toute autre manière.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Pour envoyer, recevoir sciemment, de charger, de télécharger,
            d'utiliser ou de réutiliser tout matériel qui ne respecte pas les
            normes de contenu définies dans les présentes conditions de service.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Pour transmettre ou faire envoyer tout matériel publicitaire ou
            promotionnel [sans notre accord écrit préalable], y compris tout
            &quot;courrier indésirable&quot;, &quot;lettre en chaîne&quot; ou
            &quot;spam&quot; ou toute autre sollicitation similaire.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Pour usurper ou tenter d'usurper l'identité du fournisseur, d'un
            employé du fournisseur, d'un autre utilisateur ou de toute autre
            personne ou entité (y compris, sans s'y limiter, en utilisant des
            adresses courriels ou des noms d'utilisateur associés à l'une des
            personnes susmentionnées).
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Pour adopter tout autre comportement qui limite ou empêche
            l'utilisation ou la jouissance du service par quiconque, ou qui,
            selon notre appréciation, peut nuire au fournisseur ou aux
            utilisateurs du service ou les exposer à une responsabilité.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Vous comprenez que le fournisseur peut ajouter ou supprimer ce
            service, afin de faciliter votre occupation et votre jouissance des
            locaux.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Vous comprenez que ce service peut être fourni sur une base
            temporaire uniquement et qu'il n'est pas destiné à être fourni sur
            une base permanente et ne le sera pas. Vous comprenez que le service
            temporaire n'est pas et ne sera pas considéré comme un &quot;service
            obligatoire&quot; en vertu de la loi et/ou du code de stabilisation
            des loyers.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Vous reconnaissez en outre que la suppression de ce service
            temporaire ne vous permet pas de retenir ou de déduire le loyer ou
            de demander une compensation, une réduction, une concession ou un
            abattement sur la base d'une diminution des services ou d'une
            violation de la garantie d'habitabilité en raison de conditions
            découlant de
          </span>
        </span>
      </p>
    </div>

    <span lang="FR">
      <br />
    </span>

    <div>
      <p>
        <span>
          <span lang="FR-CA">la suppression du service.</span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">En outre, vous vous engagez à ne pas :</span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Utiliser le Service d'une manière qui pourrait désactiver,
            surcharger, endommager ou détériorer le site ou interférer avec
            l'utilisation du service par d'autres parties, y compris leur
            capacité à s'engager dans des activités en temps réel par le biais
            du Service.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Utiliser un robot, une araignée ou tout autre dispositif, processus
            ou moyen automatique pour accéder au Service à quelque fin que ce
            soit, y compris pour contrôler ou copier le contenu du Service.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Utiliser tout procédé manuel pour contrôler ou copier tout élément
            du Service ou à toute autre fin non autorisée sans notre
            consentement écrit préalable.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Utiliser un dispositif, un logiciel ou une routine qui interfère
            avec le bon fonctionnement du Service.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Introduire des virus, des chevaux de Troie, des vers, des bombes
            logiques ou tout autre matériel malveillant ou technologiquement
            nuisible.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Tenter d'obtenir un accès non autorisé, d'interférer, d'endommager
            ou de perturber toute partie du Service, le serveur sur lequel le
            Service est stocké, ou tout serveur, ordinateur ou base de données
            connecté au Service.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Attaquer le Service par une attaque par déni de service ou une
            attaque par déni de service distribué.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Tenter d'entraver le bon fonctionnement du Service.
          </span>
        </span>
      </p>

      <p style={{ fontWeight: 'bold' }}>
        <span lang="EN-US">
          4.
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">ALERTES ET NOTIFICATIONS PAR SMS</span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Nous vous offrons la possibilité d’inscrire votre téléphone mobile à
            notre système d’alerte par message texte (le «&nbsp;système
            SMS&nbsp;») pour recevoir des avis de Service et des alertes
            d’urgence. Votre inscription ou votre utilisation du système SMS
            constitue votre acceptation des conditions générales
            suivantes&nbsp;:
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            En communiquant votre (vos) numéro(s) de téléphone portable au
            fournisseur dans le cadre de votre inscription au système SMS, vous
            nous donnez votre consentement exprès à recevoir des alertes par
            message texte à ce numéro et à cette adresse et :
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          i.
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            À reconnaître et nous déclarer que vous êtes l'utilisateur autorisé
            du (des) téléphone(s) mobile(s) que vous reliez à notre service de
            messages textes ou que l'utilisateur autorisé du (des) téléphone(s)
            mobile(s) vous a donné l'autorisation d'inscrire ce (ces)
            téléphone(s) mobile(s) au service;
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          ii.
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Vous accordez au Fournisseur l'autorisation expresse d'envoyer des
            messages textes à ce(s) téléphone(s) mobile(s) par l'intermédiaire
            de votre opérateur de téléphonie mobile, à moins que cette
            autorisation ne soit révoquée conformément aux présentes conditions
            générales;
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          iii.
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            La réception de messages SMS de la part du fournisseur
            (&quot;alertes SMS&quot;) ne constitue PAS une violation des règles
            nationales ou fédérales, y compris, mais sans s'y limiter, de la loi
            sur la protection des consommateurs par téléphone (TCPA) ou de la
            loi sur le contrôle de l'assaut de la pornographie et du marketing
            non sollicités (CAN-SPAM);
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          iv.
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Vous comprenez que votre opérateur de téléphonie mobile peut vous
            facturer des frais supplémentaires de messages et de données pour la
            réception de nos messages textes; et
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          v.
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            En accordant cette autorisation au fournisseur, vous demandez par la
            présente à recevoir ces messages en dépit du fait que votre numéro
            puisse figurer sur la liste fédérale ou nationale des numéros exclus
            et vous acceptez, dans toute la mesure permise par la loi, que ces
            messages textuels n'enfreignent pas cette (ces) liste(s) de numéros
            exclus.
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Avant de terminer votre inscription au Service, nous vous enverrons
            un message texte à votre numéro de téléphone portable désigné. Pour
            terminer l'inscription, vous devez confirmer la réception du message
            texte sur votre appareil en suivant les instructions qui y figurent.
            Vous pouvez annuler votre inscription au système SMS à tout moment
            en vous connectant au Service et en supprimant votre (vos) numéro(s)
            de mobile de l'enregistrement du système SMS. Vous pouvez également
            annuler votre inscription en envoyant un courriel de demande
            d'exclusion du système SMS à{' '}
          </span>
        </span>
        <span lang="EN-US">
          <a href="mailto:hello@carson.live">
            <span>
              <u>
                <span lang="FR-CA">hello@carson.live</span>
              </u>
            </span>
          </a>
        </span>
        <span>
          <span lang="FR-CA">.</span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Les alertes SMS du fournisseur sont disponibles pour les
            utilisateurs basés aux États-Unis. L'utilisateur comprend et
            reconnaît que les alertes SMS ne sont pas destinées à être
            consultées en dehors des États-Unis. En outre, étant donné que le
            fournisseur n'exploite ni ne contrôle les réseaux sans fil utilisés
            pour accéder aux alertes SMS, nous ne pouvons pas garantir la
            confidentialité ou la sécurité des transmissions de données sans
            fil. Veuillez consulter votre fournisseur de services sans fil pour
            obtenir des informations sur ses pratiques en matière de
            confidentialité et de sécurité. LE FOURNISSEUR N'EST PAS RESPONSABLE
            DES MESSAGES INCOMPLETS, PERDUS, TARDIFS OU MAL ADRESSÉS, Y COMPRIS
            (MAIS SANS S'Y LIMITER) LES MESSAGES NON DÉLIVRÉS RÉSULTANT DE TOUTE
            FORME DE FILTRAGE PAR VOTRE OPÉRATEUR DE TÉLÉPHONIE MOBILE OU VOTRE
            FOURNISSEUR DE SERVICES. LE FOURNISSEUR NE FAIT AUCUNE DÉCLARATION
            NI NE DONNE AUCUNE GARANTIE
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            QUOI QUE CE SOIT CONCERNANT LES ALERTES PAR SMS. LE SYSTÈME SMS EST
            FOURNI &quot;EN L'ÉTAT&quot; ET &quot;SELON LES
            DISPONIBILITÉS&quot;. LE FOURNISSEUR ET SES FILIALES, AFFILIÉS,
            DIRIGEANTS, AGENTS, EMPLOYÉS, PARTENAIRES ET CONCÉDANTS DE LICENCE
            DÉCLINENT EXPRESSÉMENT TOUTE GARANTIE DE QUELQUE NATURE QUE CE SOIT,
            EXPRESSE OU IMPLICITE, Y COMPRIS, MAIS SANS S'Y LIMITER, LES
            GARANTIES IMPLICITES DE QUALITÉ MARCHANDE, D'ADÉQUATION À UN USAGE
            PARTICULIER ET D'ABSENCE DE CONTREFAÇON. LE FOURNISSEUR, SES
            FILIALES, SES AFFILIÉES, SES DIRIGEANTS, SES AGENTS, SES EMPLOYÉS,
            SES PARTENAIRES ET SES CONCÉDANTS DE LICENCE NE GARANTISSENT PAS QUE
            (A) LE SYSTÈME SMS RÉPONDRA À VOS EXIGENCES; (B) LE SYSTÈME SMS SERA
            ININTERROMPU, OPPORTUN, SÉCURITAIRE OU SANS ERREUR; OU (C) LES
            RÉSULTATS QUI PEUVENT ÊTRE OBTENUS PAR L'UTILISATION DU SYSTÈME SMS
            SERONT EXACTS OU FIABLES.
          </span>
        </span>
      </p>

      <p style={{ fontWeight: 'bold' }}>
        <span lang="EN-US">
          5.
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            CONTENU DU SITE ET DROITS DE PROPRIÉTÉ INTELLECTUELLE
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Le service et l'ensemble de son contenu, de ses caractéristiques et
            de ses fonctionnalités (y compris, mais sans s'y limiter, toutes les
            informations, les logiciels, les textes, les affichages, les images,
            les vidéos et les sons, ainsi que leur conception, leur sélection et
            leur disposition) sont la propriété du fournisseur, de ses
            concédants de licence ou d'autres fournisseurs de ce matériel et
            sont protégés par les lois américaines et internationales sur les
            droits d'auteur, les marques, les brevets, les secrets commerciaux
            et d'autres droits de propriété intellectuelle ou de propriété.
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Les présentes conditions de service vous autorisent à utiliser le
            service uniquement à des fins personnelles et non commerciales. Vous
            ne devez pas reproduire, distribuer, modifier, créer des œuvres
            dérivées, afficher publiquement, exécuter publiquement, republier,
            télécharger, stocker ou transmettre le matériel de notre Service,
            sauf dans les cas suivants : * Votre ordinateur peut stocker
            temporairement des copies de ce matériel dans la mémoire vive dans
            le cadre de l'accès et de la visualisation de ce matériel.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Vous pouvez stocker des fichiers qui sont automatiquement mis en
            cache par votre navigateur Web à des fins d'amélioration de
            l'affichage.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Vous pouvez imprimer ou télécharger une copie d'un nombre
            raisonnable de pages du Service pour votre usage personnel et non
            commercial et non pour une reproduction, une publication ou une
            distribution ultérieure.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Si nous fournissons des applications de bureau, mobiles ou autres à
            télécharger, vous pouvez en télécharger une seule copie sur votre
            ordinateur ou votre appareil mobile uniquement pour votre usage
            personnel et non commercial, à condition que vous acceptiez d'être
            lié par notre accord de licence d'utilisateur final pour ces
            applications.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Si nous fournissons des fonctions de médias sociaux avec certains
            contenus, vous pouvez entreprendre les actions permises par ces
            fonctions.
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">Vous ne devez pas :</span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Modifier les copies de tout matériel provenant de ce site.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Utiliser des illustrations, des photographies, des séquences vidéo
            ou audio ou des graphiques séparément du texte qui les accompagne.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Supprimer ou modifier toute mention de droit d'auteur, de marque ou
            d'autres droits de propriété sur les copies de documents provenant
            de ce site.
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Vous ne devez pas accéder ou utiliser à des fins commerciales toute
            partie du Service ou tout service ou matériel disponible par
            l'intermédiaire du Service. Si vous imprimez, copiez, modifiez,
            téléchargez ou utilisez d'une autre manière ou donnez accès à une
            autre personne à une partie quelconque du service en violation des
            conditions de service, votre droit d'utiliser le service cessera
            immédiatement et vous devrez, à notre discrétion, renvoyer ou
            détruire toutes les copies du matériel que vous avez faites. Aucun
            droit, titre ou intérêt relatif au Service ou à son contenu ne vous
            est transféré, et tous les droits qui ne sont pas expressément
            accordés sont réservés par la Société. Toute utilisation du Service
            non expressément autorisée par les présentes constitue une violation
            des présentes conditions de service et peut enfreindre les lois sur
            les droits d'auteur, les marques commerciales et d'autres lois.
          </span>
        </span>
      </p>

      <p style={{ fontWeight: 'bold' }}>
        <span lang="EN-US">
          6.
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">MARQUES DE COMMERCE</span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Le nom et le logo de Carson, ainsi que tous les noms, logos, noms de
            produits et de services, dessins et slogans connexes sont des
            marques commerciales du Fournisseur ou de ses affiliés ou concédants
            de licence. Vous ne devez pas utiliser ces marques sans
            l'autorisation écrite préalable du fournisseur. Tous les autres
            noms, logos, noms de produits et de services, dessins et slogans
            figurant sur ce site Web sont des marques déposées de leurs
            propriétaires respectifs.
          </span>
        </span>
      </p>

      <p style={{ fontWeight: 'bold' }}>
        <span lang="EN-US">
          7.
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">CONTRIBUTIONS D'UTILISATEUR</span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Le Service peut contenir des tableaux d'affichage, des salons de
            discussion, des profils personnels, des forums, des tableaux
            d'affichage, l'intégration de médias sociaux et d'autres fonctions
            interactives (collectivement, &quot;Services interactifs&quot;) qui
            permettent aux utilisateurs de poster, soumettre, publier, afficher
            ou transmettre à d'autres utilisateurs ou à d'autres personnes
            (ci-après, &quot;poster&quot;) du contenu ou des éléments
            (collectivement, &quot;Contributions d'utilisateur&quot;) sur ou par
            l'intermédiaire du Service.
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Toutes les contributions d'utilisateur doivent être conformes aux
            normes de contenu définies dans les présentes conditions de Service.
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Toute contribution d'utilisateur que vous publiez sur le Service
            sera considérée comme non confidentielle et non exclusive. En
            fournissant une contribution d'utilisateur sur le Service, vous nous
            accordez, ainsi qu'à nos sociétés affiliées et à nos fournisseurs de
            services, et à chacun de leurs et de nos licenciés, successeurs et
            ayants droit respectifs, le droit d'utiliser, de reproduire, de
            modifier, d'exécuter, d'afficher, de distribuer et de divulguer de
            toute autre manière à des tiers tout matériel de ce type, à quelque
            fin que ce soit.
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">Vous déclarez et garantissez que :</span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Vous possédez ou contrôlez tous les droits relatifs aux
            contributions d'utilisateur et avez le droit d'accorder la licence
            susmentionnée à nous-mêmes, à nos sociétés affiliées et à nos
            fournisseurs de services, ainsi qu'à chacun de leurs et de nos
            licenciés, successeurs et ayants droit respectifs.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Toutes vos contributions d'utilisateur sont et seront conformes aux
            présentes conditions de Service.
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Vous comprenez et reconnaissez que vous êtes responsable de toute
            contribution d'utilisateur que vous soumettez ou apportez, et que
            vous, et non le fournisseur, êtes entièrement responsable de ce
            contenu, y compris de sa légalité, de sa fiabilité, de son
            exactitude et de son caractère approprié.
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Nous ne sommes pas responsables, ni redevables envers un tiers, du
            contenu ou de l'exactitude des contributions d'utilisateur publiées
            par vous ou par tout autre utilisateur du Service.
          </span>
        </span>
      </p>

      <p style={{ fontWeight: 'bold' }}>
        <span lang="EN-US">
          8.
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">NORMES DE CONTENU</span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Ces normes de contenu s'appliquent à toutes les contributions
            d'utilisateur et à l'utilisation du Service. Les contributions
            d'utilisateur doivent être entièrement conformes à toutes les lois
            et réglementations fédérales, nationales, locales et internationales
            applicables. Sans limiter la portée de ce qui précède, les
            contributions d'utilisateur ne doivent pas :
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Contenir du matériel diffamatoire, obscène, indécent, abusif,
            offensant, harcelant, violent, haineux, incendiaire ou autrement
            répréhensible.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Promouvoir du matériel sexuellement explicite ou pornographique, la
            violence ou la discrimination fondée sur la race, le sexe, la
            religion, la nationalité, le handicap, l'orientation sexuelle ou
            l'âge.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Enfreindre un brevet, une marque, un secret commercial, un droit
            d'auteur ou d'autres droits de propriété intellectuelle ou d'autres
            droits d'une autre personne.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Violer les droits légaux (y compris les droits de publicité et de
            confidentialité) d'autrui ou contenir des éléments susceptibles
            d'engager la responsabilité civile ou pénale d'autrui en vertu des
            lois ou réglementations applicables ou d'entrer en conflit avec les
            présentes conditions d'utilisation et notre politique en matière de
            confidentialité.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">Être susceptible de tromper une personne.</span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Promouvoir toute activité illégale, ou préconiser, promouvoir ou
            aider tout acte illégal.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Causer une gêne, un désagrément ou une anxiété inutile ou être
            susceptible de contrarier, d'embarrasser, d'alarmer ou d'ennuyer une
            autre personne.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Usurper l'identité d'une personne, ou présenter de manière erronée
            votre identité ou votre affiliation à une personne ou à une
            organisation.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Impliquer des activités commerciales ou des ventes, telles que des
            concours, des loteries et d'autres promotions des ventes, du troc ou
            de la publicité.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Donner l'impression qu'elles émanent de nous ou de toute autre
            personne ou entité, ou qu'elles sont approuvées par nous ou toute
            autre personne ou entité, si ce n'est pas le cas.
          </span>
        </span>
      </p>

      <p style={{ fontWeight: 'bold' }}>
        <span lang="EN-US">
          9.
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            SURVEILLANCE ET APPLICATION; CESSATION DU SERVICE
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">Nous avons le droit de :</span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Supprimer ou refuser de publier toute contribution d'utilisateur,
            pour quelque raison que ce soit ou sans raison, à notre seule
            discrétion.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Prendre toute mesure à l'égard d'une contribution d'utilisateur que
            nous jugeons nécessaire ou appropriée à notre seule discrétion, y
            compris si nous estimons que cette contribution d'utilisateur
            enfreint les conditions de service du service, y compris les normes
            de contenu, porte atteinte à un droit de propriété intellectuelle ou
            à tout autre droit d'une personne ou d'une entité, menace la
            sécurité personnelle des utilisateurs du Service ou du public ou
            pourrait engager la responsabilité du fournisseur.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Divulguer votre identité ou d'autres informations vous concernant à
            un tiers qui prétend que le matériel que vous avez publié viole ses
            droits, y compris ses droits de propriété intellectuelle ou son
            droit au respect de la confidentialité.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Prendre les mesures légales appropriées, y compris, mais sans s'y
            limiter, saisir les autorités chargées de l'application de la loi,
            pour toute utilisation illégale ou non autorisée du service.
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Résilier ou suspendre votre accès à tout ou partie du service pour
            quelque raison que ce soit ou sans raison, y compris, mais sans s'y
            limiter, toute violation des présentes conditions de service.
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Sans préjudice de ce qui précède, nous avons le droit de coopérer
            pleinement avec les autorités chargées de l'application de la loi ou
            avec les tribunaux qui nous demandent ou nous ordonnent de divulguer
            l'identité ou d'autres informations de toute personne publiant des
            documents sur ou par l'intermédiaire du Service. VOUS RENONCEZ À
            TOUTE RÉCLAMATION RÉSULTANT D'UNE MESURE PRISE PAR L'UNE DES PARTIES
            SUSMENTIONNÉES AU COURS OU À LA SUITE DE SES ENQUÊTES ET DE TOUTE
            MESURE PRISE À LA SUITE D'ENQUÊTES MENÉES PAR CES PARTIES OU PAR LES
            AUTORITÉS CHARGÉES DE L'APPLICATION DE LA LOI, ET VOUS DÉGAGEZ DE
            TOUTE RESPONSABILITÉ LA SOCIÉTÉ ET SES AFFILIÉS, DÉTENTEURS DE
            LICENCES ET FOURNISSEURS DE SERVICES À CET ÉGARD.
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Toutefois, nous ne nous engageons pas à examiner le matériel avant
            qu'il ne soit publié sur le service et nous ne pouvons pas garantir
            la suppression rapide du matériel répréhensible une fois qu'il a été
            publié. En conséquence, nous n'assumons aucune responsabilité pour
            toute action ou inaction concernant les transmissions, les
            communications ou le contenu fourni par un utilisateur ou un tiers.
            Nous n'avons aucune responsabilité envers qui que ce soit en ce qui
            concerne l'exécution ou la non-exécution des activités décrites dans
            cette section.
          </span>
        </span>
      </p>
    </div>

    <span lang="FR">
      <br />
    </span>

    <div>
      <p
        style={{
          marginTop: '0cm',
          marginRight: '0cm',
          marginBottom: '10.0pt',
          marginLeft: '0cm',
          textIndent: '0cm',
          pageBreakAfter: 'avoid',
          fontWeight: 'bold',
        }}
      >
        <span lang="EN-US">
          10.
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">VIOLATION DES DROITS D'AUTEUR</span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Carson Living, Inc. a pour politique de répondre aux plaintes pour
            violation de la propriété intellectuelle. Nous examinerons
            rapidement les avis d'infraction présumée et prendrons les mesures
            appropriées requises en vertu du Digital Millennium Copyright Act,
            Titre 17, United States Code, Section 512(c)(2) (&quot;DMCA&quot;)
            et d'autres lois applicables en matière de propriété intellectuelle.
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Conformément au DMCA, les notifications de violation présumée des
            droits d'auteur doivent être envoyées à l'agent désigné du
            fournisseur de services. La notification doit être soumise à l'agent
            désigné suivant de Carson Living, Inc :{' '}
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">&nbsp;</span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">Carson Living, Inc.</span>
        </span>
      </p>

      <p>
        <span>
          <span lang="EN-US">85 Fifth Ave, 4e étage</span>
        </span>
      </p>

      <p>
        <span>
          <span lang="EN-US">New York, NY 10003</span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">ÉTATS-UNIS</span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">Courriel : </span>
        </span>
        <span lang="EN-US">
          <a href="mailto:hello@carson.live">
            <span>
              <u>
                <span lang="FR-CA">hello@carson.live</span>
              </u>
            </span>
          </a>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Pour être efficace, la notification doit être une communication
            écrite qui comprend les éléments suivants :
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            La signature physique ou électronique d'une personne autorisée à
            agir au nom du titulaire du droit d'auteur violé;
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            L'identification de l'œuvre protégée par des droits d'auteur qui
            aurait été violée ou, si plusieurs œuvres protégées par des droits
            d'auteur sur un seul site en ligne sont couvertes par une seule
            notification, une liste représentative de ces œuvres sur ce site;
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            L'identification du matériel considéré comme contrefait ou faisant
            l'objet d'une activité contrefaite et qui doit être retiré ou dont
            l'accès doit être désactivé, ainsi que des informations
            raisonnablement suffisantes pour permettre au fournisseur de
            services de localiser le matériel;
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Des informations raisonnablement suffisantes pour permettre au
            fournisseur de services de contacter la partie plaignante, telles
            qu'une adresse, un numéro de téléphone et, le cas échéant, une
            adresse courriel à laquelle la partie plaignante peut être
            contactée;
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Une déclaration selon laquelle la partie plaignante croit de bonne
            foi que l'utilisation du matériel de la manière faisant l'objet de
            la plainte n'est pas autorisée par le détenteur des droits d'auteur,
            son agent ou la loi; et
          </span>
        </span>
      </p>

      <p>
        <span lang="EN-US">
          •
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            Une déclaration selon laquelle les informations contenues dans la
            notification sont exactes et, sous peine de parjure, que la partie
            plaignante est autorisée à agir au nom du titulaire des droits
            d'auteur.
          </span>
        </span>
      </p>

      <p
        style={{
          marginTop: '0cm',
          marginRight: '0cm',
          marginBottom: '10.0pt',
          marginLeft: '0cm',
          textIndent: '0cm',
          pageBreakAfter: 'avoid',
          fontWeight: 'bold',
        }}
      >
        <span lang="EN-US">
          11.
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;{' '}
          </span>
        </span>
        <span>
          <span lang="FR-CA">LIENS VERS DES TIERS</span>
        </span>
      </p>

      <p style={{ marginBottom: '10.0pt', textAlign: 'justify' }}>
        <span>
          <span lang="FR-CA">
            Si le Service contient des liens vers d'autres sites et ressources
            fournis par des tiers, ces liens ne sont fournis que pour votre
            commodité. Cela inclut les liens contenus dans les publicités, y
            compris les bannières publicitaires et les liens sponsorisés. Nous
            n'avons aucun contrôle sur le contenu de ces sites ou ressources, et
            nous n'acceptons aucune responsabilité à leur égard ou à l'égard de
            toute perte ou de tout dommage pouvant résulter de leur utilisation.
            Si vous décidez d'accéder à l'un des sites Web ou services de tiers
            liés à ce service, vous le faites entièrement à vos propres risques
            et sous réserve des conditions générales de ces sites Web.
          </span>
        </span>
      </p>

      <p style={{ fontWeight: 'bold' }}>
        <span lang="EN-US">
          12.
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">
            CONTRÔLE DE L'ACCÈS À LA PLATEFORME DE SURVEILLANCE
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Dans la mesure où vous avez obtenu un accès direct à la plateforme
            de surveillance du fournisseur, vous permettant de suivre et/ou de
            contrôler certains aspects du service (la &quot;plateforme de
            surveillance&quot;), vous acceptez que votre accès à la plateforme
            de surveillance soit subordonné aux engagements suivants : Vous
            acceptez et vous vous engagez à ce que le format, le contenu, la
            conception et les services de la plateforme de surveillance (la
            &quot;propriété intellectuelle de la plateforme de
            surveillance&quot;) soient des informations exclusives et
            confidentielles du fournisseur et vous ne devez pas : (i) utiliser
            la propriété intellectuelle de la plateforme de surveillance ou
            toute partie de celle-ci à d'autres fins que dans le cadre de votre
            utilisation du Service approuvée par le fournisseur; (ii) divulguer
            la propriété intellectuelle de la plateforme de surveillance ou
            toute partie de celle-ci à un tiers, sans l'accord écrit préalable
            du fournisseur; (iii) copier ou reproduire directement ou
            indirectement tout ou partie de la propriété intellectuelle de la
            plateforme de surveillance; (iv) chercher à reproduire directement
            ou indirectement tout ou partie de la propriété intellectuelle de la
            plateforme de surveillance; et (iv) chercher à développer
            directement ou indirectement un produit dont les caractéristiques
            sont similaires à celles de la plateforme de surveillance ou du
            service, ou qui concurrence directement ou indirectement la
            plateforme de surveillance ou le service ou toute partie de ceux-ci,
            pendant la durée de votre accord avec le fournisseur et pendant une
            période de deux ans par la suite; (v) contourner ou tenter de
            contourner les engagements contenus dans le présent document. Vous
            reconnaissez que le fournisseur subira un préjudice irréparable si
            vos engagements ne sont pas spécifiquement mis en œuvre et que le
            fournisseur ne disposera pas d'un recours juridique adéquat en cas
            de violation réelle ou de menace de violation de ces obligations par
            vous. Par conséquent, en plus de tous les autres recours dont il
            peut disposer, le fournisseur a droit à une injonction ou à tout
            décret approprié d'exécution spécifique pour toute violation ou
            infraction réelle ou potentielle de votre part, sans avoir à
            démontrer l'existence d'un dommage réel.
          </span>
        </span>
      </p>

      <p
        style={{
          marginTop: '0cm',
          marginRight: '0cm',
          marginBottom: '10.0pt',
          marginLeft: '0cm',
          textIndent: '0cm',
          pageBreakAfter: 'avoid',
          fontWeight: 'bold',
        }}
      >
        <span lang="EN-US">
          13.
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">EXCLUSION DE GARANTIE</span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            L'UTILISATION DU SERVICE, DE SON CONTENU ET DE TOUT SERVICE OU
            ÉLÉMENT OBTENU PAR LE BIAIS DU SERVICE SE FAIT À VOS PROPRES
            RISQUES. LE SERVICE, SON CONTENU ET TOUS LES SERVICES OU ÉLÉMENTS
            OBTENUS PAR LE BIAIS DU SERVICE SONT FOURNIS &quot;EN L'ÉTAT&quot;
            ET &quot;TELS QUE DISPONIBLES&quot;, SANS AUCUNE GARANTIE D'AUCUNE
            SORTE, EXPRESSE OU IMPLICITE. NI LA SOCIÉTÉ NI AUCUNE PERSONNE
            ASSOCIÉE À LA SOCIÉTÉ NE DONNE DE GARANTIE OU NE FAIT DE DÉCLARATION
            CONCERNANT L'EXHAUSTIVITÉ, LA SÉCURITÉ, LA FIABILITÉ, LA QUALITÉ,
            L'EXACTITUDE OU LA DISPONIBILITÉ DU SERVICE. SANS LIMITER LA PORTÉE
            DE CE QUI PRÉCÈDE, NI LA SOCIÉTÉ NI AUCUNE PERSONNE ASSOCIÉE À LA
            SOCIÉTÉ NE DÉCLARE OU NE GARANTIT QUE LE SERVICE, SON CONTENU OU
            TOUT SERVICE OU ÉLÉMENT OBTENU PAR LE BIAIS DU SERVICE SERA EXACT,
            FIABLE, SANS ERREUR OU ININTERROMPU, QUE LES DÉFAUTS SERONT
            CORRIGÉS, QUE NOTRE SITE OU LE SERVEUR QUI LE REND DISPONIBLE SONT
            EXEMPTS DE VIRUS OU D'AUTRES COMPOSANTS NUISIBLES OU QUE LE SERVICE
            OU TOUT SERVICE OU ÉLÉMENT OBTENU PAR LE BIAIS DU SERVICE RÉPONDRA À
            VOS BESOINS OU À VOS ATTENTES.
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            LA SOCIÉTÉ DÉCLINE PAR LA PRÉSENTE TOUTE GARANTIE DE QUELQUE NATURE
            QUE CE SOIT, EXPRESSE OU IMPLICITE, LÉGALE OU AUTRE, Y COMPRIS, MAIS
            SANS S'Y LIMITER, TOUTE GARANTIE DE QUALITÉ MARCHANDE, D'ABSENCE DE
            CONTREFAÇON ET D'ADÉQUATION À UN USAGE PARTICULIER.
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            CE QUI PRECEDE N'AFFECTE PAS LES GARANTIES QUI NE PEUVENT ETRE
            EXCLUES OU LIMITEES EN VERTU DE LA LOI APPLICABLE.
          </span>
        </span>
      </p>

      <p style={{ fontWeight: 'bold' }}>
        <span lang="EN-US">
          14.
          <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>

        <span>
          <span lang="FR-CA">LIMITATION DE LA RESPONSABILITÉ</span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            EN AUCUN CAS LE FOURNISSEUR, SES AFFILIÉS OU LEURS CONCÉDANTS DE
            LICENCE, FOURNISSEURS DE SERVICES, EMPLOYÉS, AGENTS, DIRIGEANTS OU
            ADMINISTRATEURS NE SERONT RESPONSABLES DES DOMMAGES DE TOUTE NATURE,
            EN VERTU DE TOUTE THÉORIE JURIDIQUE, DÉCOULANT DE OU EN RAPPORT AVEC
            VOTRE UTILISATION, OU VOTRE INCAPACITÉ À UTILISER, LE SERVICE, TOUT
            SERVICE LIÉ À CELUI-CI, TOUT CONTENU SUR LE SERVICE OU TOUT SERVICE
            OU ARTICLE OBTENU PAR L'INTERMÉDIAIRE DU SERVICE, Y COMPRIS TOUT
            DOMMAGE DIRECT, DOMMAGES DIRECTS, INDIRECTS, SPÉCIAUX, ACCESSOIRES,
            CONSÉCUTIFS OU PUNITIFS, Y COMPRIS, MAIS SANS S'Y LIMITER, LES
            DOMMAGES CORPORELS, LA DOULEUR ET LA SOUFFRANCE, LA DÉTRESSE
            ÉMOTIONNELLE, LA PERTE DE REVENUS, LA PERTE DE PROFITS, LA PERTE
            D'AFFAIRES OU D'ÉCONOMIES ANTICIPÉES, LA PERTE D'UTILISATION, LA
            PERTE DE CLIENTÈLE, LA PERTE DE DONNÉES, ET CE, QU'ILS SOIENT CAUSÉS
            PAR UN DÉLIT CIVIL (Y COMPRIS LA NÉGLIGENCE), UNE RUPTURE DE CONTRAT
            OU AUTRE, MÊME S'ILS SONT PRÉVISIBLES.
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            CE QUI PRECEDE N'AFFECTE PAS LES GARANTIES QUI NE PEUVENT ETRE
            EXCLUES OU LIMITEES EN VERTU DE LA LOI APPLICABLE. SAUF EN CAS
            D'ACTES DÉLICTUEUX OU CRIMINELS DÉLIBÉRÉS OU MALVEILLANTS DE LA PART
            DU FOURNISSEUR, VOUS ACCEPTEZ QU'EN AUCUN CAS LA RESPONSABILITÉ
            COLLECTIVE DU FOURNISSEUR (ET DE SES SOCIÉTÉS AFFILIÉES, PARENTS,
            FILIALES, DIRIGEANTS, EMPLOYÉS, ADMINISTRATEURS, AGENTS ET
            FOURNISSEURS) N'EXCÈDE LE MONTANT LE PLUS ÉLEVÉ ENTRE 2 500 $ (DEUX
            MILLE CINQ CENTS DOLLARS) ET LE MONTANT DES SOMMES QUE VOUS AVEZ
            VERSÉES AU FOURNISSEUR AU COURS DE LA PÉRIODE DE DOUZE MOIS
            PRÉCÉDANT IMMÉDIATEMENT L'ACTE À L'ORIGINE DE LA RESPONSABILITÉ.
          </span>
        </span>
      </p>

      <p
        style={{
          marginLeft: '0cm',
          textIndent: '0cm',
          pageBreakAfter: 'avoid',
          fontWeight: 'bold',
        }}
      >
        <span lang="EN-US">
          15.
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">INDEMNISATION</span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Vous acceptez de défendre, d'indemniser et de dégager de toute
            responsabilité le fournisseur, ses sociétés affiliées, ses
            concédants de licence et ses fournisseurs de services, ainsi que
            leurs dirigeants, administrateurs, employés, contractants, agents,
            concédants de licence, fournisseurs, successeurs et ayants droit
            respectifs, en cas de réclamation, de responsabilité, de dommages,
            de jugements, de récompenses, de pertes, de coûts, (y compris les
            frais raisonnables d'avocat) découlant de ou liés à votre violation
            des présentes conditions de service ou à votre utilisation du
            Service, y compris, mais sans s'y limiter, vos contributions
            d'utilisateur, toute utilisation du contenu, des services et des
            produits du service autre que celle expressément autorisée dans les
            présentes conditions de service ou votre utilisation de toute
            information obtenue à partir du service.
          </span>
        </span>
      </p>

      <p
        style={{
          marginLeft: '0cm',
          textIndent: '0cm',
          pageBreakAfter: 'avoid',
          fontWeight: 'bold',
        }}
      >
        <span lang="EN-US">
          16.
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">DROIT APPLICABLE ET JURIDICTION</span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Toutes les questions relatives au service et aux présentes
            conditions de service, ainsi que tout litige ou toute réclamation en
            découlant ou s'y rapportant (dans chaque cas, y compris les litiges
            ou réclamations non contractuels), sont régis et interprétés
            conformément aux lois internes de l'État de New York, sans donner
            effet à aucune disposition ou règle de choix ou de conflit de lois
            (que ce soit dans l'État de New York ou dans toute autre
            juridiction).
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Tout procès, action ou procédure découlant des présentes conditions
            de service ou du service, ou s'y rapportant, doit être intenté
            exclusivement devant les tribunaux de l'État de New York, dans
            chaque cas situé dans la ville de New York et le comté de New York,
            bien que nous conservions le droit d'intenter un procès, une action
            ou une procédure contre vous pour violation des présentes conditions
            de service dans votre pays de résidence ou dans tout autre pays
            concerné. Vous renoncez à toute objection à l'exercice de la
            juridiction sur vous par ces tribunaux et à la compétence de ces
            tribunaux.
          </span>
        </span>
      </p>

      <p
        style={{
          marginLeft: '0cm',
          textIndent: '0cm',
          pageBreakAfter: 'avoid',
          fontWeight: 'bold',
        }}
      >
        <span lang="EN-US">
          17.
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">LIMITATION DU DÉLAI DE DÉPÔT DES DEMANDES</span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            TOUTE CAUSE D'ACTION OU DE RÉCLAMATION QUE VOUS POURRIEZ AVOIR
            DÉCOULANT DE OU LIÉE AUX PRÉSENTES CONDITIONS DE SERVICE OU AU
            SERVICE DOIT ÊTRE INTRODUITE DANS UN DÉLAI D'UN (1) AN APRÈS LA
            SURVENANCE DE LA CAUSE D'ACTION, FAUTE DE QUOI LADITE CAUSE D'ACTION
            OU RÉCLAMATION EST DÉFINITIVEMENT PRESCRITE.
          </span>
        </span>
      </p>

      <p
        style={{
          marginLeft: '0cm',
          textIndent: '0cm',
          pageBreakAfter: 'avoid',
          fontWeight: 'bold',
        }}
      >
        <span lang="EN-US">
          18.
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA">RENONCIATION ET DIVISIBILITÉ</span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Aucune renonciation par le fournisseur à l'une des conditions
            énoncées dans les présentes conditions de service ne sera considérée
            comme une renonciation ultérieure ou permanente à cette condition ou
            comme une renonciation à toute autre condition, et le fait pour le
            fournisseur de ne pas faire valoir un droit ou une disposition en
            vertu des présentes conditions de service ne constituera pas une
            renonciation à ce droit ou à cette disposition.
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Si une disposition des présentes conditions de service est jugée
            invalide, illégale ou inapplicable pour quelque raison que ce soit
            par une cour ou un autre tribunal compétent, cette disposition sera
            supprimée ou limitée au minimum de sorte que les autres dispositions
            des conditions de service resteront pleinement en vigueur.
          </span>
        </span>
      </p>

      <p
        style={{
          marginLeft: '0cm',
          textIndent: '0cm',
          pageBreakAfter: 'avoid',
          fontWeight: 'bold',
        }}
      >
        <span lang="EN-US">
          19.
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span>
          <span lang="FR-CA" style={{ textTransform: 'uppercase' }}>
            Accord intégral.
          </span>
        </span>
      </p>

      <p>
        <span>
          <span lang="FR-CA">
            Les conditions de service et notre politique de confidentialité
            constituent le seul et unique accord entre vous et le fournisseur en
            ce qui concerne le service et remplacent tous les accords,
            conventions, déclarations et garanties antérieurs et contemporains,
            tant écrits qu'oraux, en ce qui concerne le service.
          </span>
        </span>
      </p>
    </div>
  </>
);
